import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";

// ============================================================================
// payment_methods — วิธีชำระเงิน (ตั้งค่าได้)
// ============================================================================
export const paymentMethods = sqliteTable("accounting_payment_methods", {
  id: text("id").primaryKey(), // ULID — used as foreign key by accounting_payments.payment_method
  companyId: text("company_id").notNull(),
  name: text("name").notNull(), // e.g., "เงินสด", "โอนเงิน"
  accountId: text("account_id"), // FK → accounts (บัญชีที่ผูก เช่น เงินสด, ธนาคาร)
  requiresReference: integer("requires_reference").notNull().default(1), // 0=cash-like (no reference needed), 1=needs reference number
  isDefault: integer("is_default").notNull().default(0), // 0=ไม่ใช่, 1=ค่าเริ่มต้น
  isActive: integer("is_active").notNull().default(1),
  // System-seeded rows (from seedAccountingData) get is_system=1 so the UI can
  // render the "ระบบ" badge and the DELETE handler can block removal with 409.
  // Default 0 — user-created rows are deletable. See issue #344.
  isSystem: integer("is_system").notNull().default(0),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  // ม.87/3 compliance — historical payments may FK here; never hard-delete.
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type PaymentMethod = typeof paymentMethods.$inferSelect;
export type NewPaymentMethod = typeof paymentMethods.$inferInsert;
